import * as React from "react";
import { Layout } from "antd";
import { useState, useEffect } from "src/ReactTS";
import { LinkType } from "../../../services/interfaces/ILinkType";
import { useContext } from "src/ReactTS";
import { AuthContext } from "src/components/context/AuthContext";
import "./LandingLayout.scss";

///////////////////////////////////////////
//        Decode

import Header from "../header";
import Footer from "../footer";

//
///////////////////////////////////////////

export const LandingLayout: React.SFC<any> = props => {
  const [menuTheme, setMenuTheme] = useState("transparent");
  const pathname = props.location.pathname as string;
  const customLayoutMap = {
    "/sobre": "dark"
  };
  const { currentEmail, currentUser } = useContext(AuthContext);
  const updateTheme = () => {
    const scrollYThreshold = 1;
    if (window.scrollY > scrollYThreshold && menuTheme !== "scrolling") {
      setMenuTheme("scrolling");
    } else if (window.scrollY <= scrollYThreshold) {
      const actualTheme = customLayoutMap[pathname] || "white";

      if (actualTheme !== menuTheme) {
        setMenuTheme(actualTheme);
      }
    }
  };

  const changeMenuThemeOnScroll = () => updateTheme();

  useEffect(() => {
    updateTheme();
    window.addEventListener("scroll", changeMenuThemeOnScroll);
    return function cleanup() {
      window.removeEventListener("scroll", changeMenuThemeOnScroll);
    };
  });

  const links =
    currentEmail && currentUser
      ? [
          { link: "/meus-precatorios/resumo", text: "Meus precatórios", linkType: LinkType.internal },
          { link: "https://precatoriosbrasil.com/faq?source=loggedInAppPrecatorios", text: "FAQ", linkType: LinkType.external, newTab: true },
          {
            link: "/logout",
            text: "Sair",
            linkType: LinkType.internal
          }
        ]
      : [
          { link: "https://precatoriosbrasil.com?source=unloggedAppPrecatorios", text: "Início", linkType: LinkType.external, newTab: false },
          { link: "https://blog.precatoriosbrasil.com?source=unloggedAppPrecatorios", text: "Blog", linkType: LinkType.external, newTab: true },
          { link: "https://precatoriosbrasil.com/sobre?source=unloggedAppPrecatorios", text: "Sobre nós", linkType: LinkType.external, newTab: false },
          { link: "https://precatoriosbrasil.com/faq?source=unloggedAppPrecatorios", text: "FAQ", linkType: LinkType.external, newTab: false },
          { link: "/", text: "Entrar", linkType: LinkType.internal }
        ];
  return (
    <Layout className="layout" style={{ minHeight: "100%", backgroundColor: "#FFF" }}>
      <Header NavigationItems={links} />
      <Layout.Content>{props.children}</Layout.Content>
      <Footer />
    </Layout>
  );
};



// WEBPACK FOOTER //
// ./src/components/template/layouts/LandingLayout.tsx